(function () {
  // Run fn once document.body exists (safe even if this script
  // is loaded in <head> without defer)
  function whenBodyReady(fn) {
    if (document.body) fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var saved = null;
  var restoreAttempts = 0;
  var MAX_RESTORE_ATTEMPTS = 10;

  // ---- Remount logic: restore Algolia's search if the theme wipes it ----

  function findMount() {
    try { return document.querySelector('.algolia-desktop-search .aa-Autocomplete'); }
    catch (e) { return null; }
  }

  function findForm() {
    try { return document.querySelector('.algolia-desktop-search .algolia-search-form'); }
    catch (e) { return null; }
  }

  function restore() {
    try {
      if (restoreAttempts >= MAX_RESTORE_ATTEMPTS) return;
      var form = findForm();
      if (form && saved && !findMount()) {
        restoreAttempts++;
        form.appendChild(saved);
      }
    } catch (e) {
      console.warn('[algolia-remount] restore failed:', e);
    }
  }

  function checkRemount() {
    try {
      var mount = findMount();
      if (mount) {
        saved = mount;
        restoreAttempts = 0;
        handOff();
        return;
      }
      if (saved) restore();
    } catch (e) {
      console.warn('[algolia-remount] observer error:', e);
    }
  }

  // ---- One shared DOM observer ----
  // Remount, placeholder, clear button and mobile placement all have to
  // react when the header is re-rendered. They used to be four separate
  // observers on <body>, each running its querySelectors on every DOM
  // change, and apps (Intercom, Klaviyo, pixels) change the DOM a lot after
  // load. Now one observer batches all changes into a single pass per frame.
  var checksQueued = false;

  function runChecks() {
    checksQueued = false;
    checkRemount();
    enforcePlaceholder();
    syncClearButton();
    checkMobilePlacement();
  }

  var domObserver = new MutationObserver(function () {
    if (checksQueued) return;
    checksQueued = true;
    requestAnimationFrame(runChecks);
  });

  function start() {
    try {
      var mount = findMount();
      if (mount) {
        saved = mount;
        handOff();
      }
      domObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['placeholder', 'open']
      });
      enforcePlaceholder();
      applySearchMode(); // mobile/desktop placement (see below)
    } catch (e) {
      console.warn('[algolia-remount] failed to start:', e);
    }
  }

  // ---- Hand typed text from the static input to Algolia ----
  // snippets/search.liquid renders a plain .algolia-search-input so the bar
  // can be typed in before Algolia loads. Algolia then replaces the whole
  // form, static input included, so what was typed and whether it had focus
  // are recorded as they happen and replayed into .aa-Input on mount.

  var handedOff = false;
  var typedValue = '';
  var typedFocus = false;

  function isStaticInput(el) {
    return el && el.classList && el.classList.contains('algolia-search-input');
  }

  document.addEventListener('input', function (e) {
    if (isStaticInput(e.target)) typedValue = e.target.value;
  }, true);
  document.addEventListener('focusin', function (e) {
    if (isStaticInput(e.target)) typedFocus = true;
  }, true);
  document.addEventListener('focusout', function (e) {
    if (isStaticInput(e.target)) typedFocus = false;
  }, true);

  function handOff() {
    try {
      if (handedOff) return;
      var wrapper = document.querySelector('.algolia-desktop-search');
      var aaInput = wrapper && wrapper.querySelector('.aa-Input');
      if (!aaInput) return;
      handedOff = true;
      if (typedValue && !aaInput.value) {
        aaInput.value = typedValue;
        aaInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (typedFocus || typedValue) aaInput.focus();
    } catch (e) {}
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  // ---- Placeholder enforcement ----

  var PLACEHOLDER = 'What are you looking for?';

  function enforcePlaceholder() {
    try {
      var input = document.querySelector('.algolia-desktop-search .aa-Input');
      if (input && input.getAttribute('placeholder') !== PLACEHOLDER) {
        input.setAttribute('placeholder', PLACEHOLDER);
      }
    } catch (e) {}
  }

  // ---- Custom clear button (Algolia's own is broken post-remount) ----

  function ensureClearButton() {
    try {
      var form = document.querySelector('.algolia-desktop-search .aa-Form');
      if (!form) return null;
      var btn = form.querySelector('.custom-aa-clear');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'custom-aa-clear';
        btn.setAttribute('aria-label', 'Clear search');
        btn.innerHTML = '&#10005;';
        form.appendChild(btn);
      }
      return btn;
    } catch (e) { return null; }
  }

  function syncClearButton() {
    try {
      var input = document.querySelector('.algolia-desktop-search .aa-Input');
      var btn = ensureClearButton();
      if (!input || !btn) return;
      btn.classList.toggle('visible', input.value.length > 0);
    } catch (e) {}
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('aa-Input')) {
      syncClearButton();
    }
  }, true);

  document.addEventListener('click', function (e) {
    try {
      var btn = e.target.closest && e.target.closest('.custom-aa-clear');
      if (!btn) return;
      e.preventDefault();
      var input = document.querySelector('.algolia-desktop-search .aa-Input');
      if (input) {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }
      syncClearButton();
    } catch (err) {}
  }, true);

  // =====================================================
  // MOBILE SEARCH — fullscreen Algolia overlay
  //
  // On <=749px the theme header stays native (hamburger /
  // logo / magnifier icon). Tapping ANY header search
  // trigger is hijacked: instead of the theme's search,
  // a fullscreen overlay opens containing the relocated
  // .algolia-desktop-search wrapper (instance + listeners
  // intact). On desktop the wrapper is returned to its
  // original header position.
  // =====================================================

  var MOBILE_MQ;
  try { MOBILE_MQ = window.matchMedia('(max-width: 749px)'); } catch (e) { MOBILE_MQ = null; }

  var IN_APP_HOST_TIMEOUT_MS = 15000;

  var originalParent = null;
  var originalNextSibling = null;

  function isInApp() {
    return document.documentElement.classList.contains('in-app');
  }

  function ensureInAppHost() {
    try {
      var host = document.getElementById('sfss-in-app-autocomplete-host');
      if (!host) {
        host = document.createElement('div');
        host.id = 'sfss-in-app-autocomplete-host';
        host.setAttribute('aria-hidden', 'true');
        host.style.position = 'fixed';
        host.style.top = '0';
        host.style.left = '-10000px';
        host.style.width = '320px';
        host.style.height = '48px';
        host.style.display = 'block';
        host.style.visibility = 'visible';
        host.style.opacity = '1';
        host.style.pointerEvents = 'none';
        document.body.appendChild(host);
      }
      return host;
    } catch (e) {
      return null;
    }
  }

  function moveToInAppHost() {
    try {
      if (!isInApp()) return;
      var wrapper = getSearchWrapper();
      if (!wrapper) return;
      var host = ensureInAppHost();
      if (!host || wrapper.parentNode === host) return;
      originalParent = wrapper.parentNode;
      originalNextSibling = wrapper.nextSibling;
      host.appendChild(wrapper);
    } catch (e) {
      console.warn('[algolia-in-app] moveToInAppHost failed:', e);
    }
  }

  var inAppHostSettled = false;

  function settleInAppHost() {
    if (inAppHostSettled || !isInApp()) return false;
    var wrapper = getSearchWrapper();
    var mount = findMount();
    if (!wrapper || !mount) return false;
    moveToInAppHost();
    inAppHostSettled = true;
    return true;
  }

  function startInAppHostObserver() {
    if (!isInApp() || inAppHostSettled) return;

    whenBodyReady(function () {
      if (settleInAppHost()) return;

      var observer = new MutationObserver(function () {
        if (settleInAppHost()) observer.disconnect();
      });

      var timeoutId = setTimeout(function () {
        inAppHostSettled = true;
        observer.disconnect();
      }, IN_APP_HOST_TIMEOUT_MS);

      observer.observe(document.body, { childList: true, subtree: true });

      if (settleInAppHost()) {
        clearTimeout(timeoutId);
        observer.disconnect();
      }
    });
  }

  startInAppHostObserver();

  function getSearchWrapper() {
    try {
      return document.querySelector('.header-search-dropdown.algolia-desktop-search') ||
             document.querySelector('.algolia-desktop-search');
    } catch (e) { return null; }
  }

  function ensureMobileHost() {
    try {
      var host = document.getElementById('custom-mobile-algolia-search');
      if (!host) {
        host = document.createElement('div');
        host.id = 'custom-mobile-algolia-search';

        var bar = document.createElement('div');
        bar.className = 'custom-mobile-search-bar';

        var slot = document.createElement('div');
        slot.className = 'custom-mobile-search-slot';

        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'custom-mobile-search-close';
        close.setAttribute('aria-label', 'Close search');
        close.innerHTML = '&#10005;';
        close.addEventListener('click', closeMobileSearch);

        bar.appendChild(slot);
        bar.appendChild(close);
        host.appendChild(bar);
        document.body.appendChild(host);
      }
      return host;
    } catch (e) { return null; }
  }

  function moveToMobile() {
    try {
      if (isInApp()) return;
      var wrapper = getSearchWrapper();
      if (!wrapper) return;
      var host = ensureMobileHost();
      if (!host) return;
      var slot = host.querySelector('.custom-mobile-search-slot');
      if (!slot || wrapper.parentNode === slot) return;
      originalParent = wrapper.parentNode;
      originalNextSibling = wrapper.nextSibling;
      slot.appendChild(wrapper);
    } catch (e) {
      console.warn('[algolia-mobile] moveToMobile failed:', e);
    }
  }

  function moveToDesktop() {
    try {
      closeMobileSearch();
      var wrapper = getSearchWrapper();
      if (!wrapper || !originalParent) return;
      if (wrapper.parentNode === originalParent) return;
      if (!document.body.contains(originalParent)) {
        originalParent =
          document.querySelector('.header__column--center .search-action') ||
          document.querySelector('.header__column--center') ||
          null;
        originalNextSibling = null;
        if (!originalParent) return;
      }
      if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
        originalParent.insertBefore(wrapper, originalNextSibling);
      } else {
        originalParent.appendChild(wrapper);
      }
    } catch (e) {
      console.warn('[algolia-mobile] moveToDesktop failed:', e);
    }
  }

  function ensureFallbackSearch(host) {
    try {
      var slot = host.querySelector('.custom-mobile-search-slot');
      if (!slot) return;
      // If the Algolia wrapper made it into the slot, remove any fallback
      var hasAlgolia = !!slot.querySelector('.algolia-desktop-search');
      var fallback = slot.querySelector('.custom-fallback-search');
      if (hasAlgolia) {
        if (fallback) fallback.remove();
        return;
      }
      if (fallback) return;
      // No Algolia instance available on mobile — plain search form
      // that submits to /search (Algolia InstantSearch page handles q=)
      fallback = document.createElement('form');
      fallback.className = 'custom-fallback-search';
      fallback.setAttribute('action', '/search');
      fallback.setAttribute('method', 'get');
      fallback.innerHTML =
        '<input class="custom-fallback-search-input" type="search" name="q" ' +
        'placeholder="What are you looking for?" autocomplete="off">';
      slot.appendChild(fallback);
    } catch (e) {}
  }

  function openMobileSearch() {
    try {
      moveToMobile(); // make sure the wrapper is in the overlay host

      // If Algolia's detached mode is active, use ITS fullscreen UI —
      // don't open our overlay on top of it (that's double-UI soup).
      var wrapper = getSearchWrapper();
      var detachedBtn = wrapper &&
        wrapper.querySelector('.aa-DetachedSearchButton');
      if (detachedBtn) {
        closeMobileSearch(); // make sure our overlay is not also open
        detachedBtn.click(); // opens Algolia's own fullscreen search
        return;
      }

      // Otherwise (inline autocomplete or no Algolia at all): our overlay
      var host = ensureMobileHost();
      if (!host) return;
      ensureFallbackSearch(host);
      host.classList.add('open');
      document.body.classList.add('custom-mobile-search-open');
      var input = host.querySelector('.aa-Input') ||
                  host.querySelector('.algolia-search-input') ||
                  host.querySelector('.custom-fallback-search-input');
      if (input) {
        setTimeout(function () { try { input.focus(); } catch (e) {} }, 50);
      }
    } catch (e) {}
  }

  function closeMobileSearch() {
    try {
      var host = document.getElementById('custom-mobile-algolia-search');
      if (host) host.classList.remove('open');
      document.body.classList.remove('custom-mobile-search-open');
    } catch (e) {}
  }

  function applySearchMode() {
    try {
      if (isInApp()) {
        moveToInAppHost();
        return;
      }
      if (!MOBILE_MQ) return;
      if (MOBILE_MQ.matches) moveToMobile();
      else moveToDesktop();
    } catch (e) {}
  }

  if (MOBILE_MQ) {
    try {
      if (typeof MOBILE_MQ.addEventListener === 'function') {
        MOBILE_MQ.addEventListener('change', applySearchMode);
      } else if (typeof MOBILE_MQ.addListener === 'function') {
        MOBILE_MQ.addListener(applySearchMode); // older Safari
      }
    } catch (e) {}
  }

  // ---- Hijack the theme's header search icon on mobile ----
  // Capture-phase listener fires before the theme's own handlers,
  // so the native Shopify search never opens.
  var SEARCH_TRIGGER_SELECTORS = [
    'a[href*="/search"]',
    'button[aria-label*="search" i]',
    'a[aria-label*="search" i]',
    'summary[aria-label*="search" i]',
    '[class*="search-toggle"]',
    '[class*="search-modal__button"]',
    '[class*="header-search__button"]',
    '.search-action button',
    '.search-action a'
  ].join(',');

  function hijackHandler(e) {
    try {
      if (isInApp()) return;
      if (!MOBILE_MQ || !MOBILE_MQ.matches) return;
      if (!e.target || !e.target.closest) return;
      // Never hijack interactions inside our own overlay
      if (e.target.closest('#custom-mobile-algolia-search')) return;
      var trigger = e.target.closest(SEARCH_TRIGGER_SELECTORS);
      if (!trigger) return;
      // Only header search triggers, not random /search links in content
      var header =
        trigger.closest('#shopify-section-header') ||
        trigger.closest('header') ||
        trigger.closest('.header');
      if (!header) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      // Only open once, on the event most likely to be first
      if (e.type === 'pointerdown' || e.type === 'touchstart' || e.type === 'click') {
        openMobileSearch();
      }
    } catch (err) {}
  }

  // Themes open search on pointerdown/mousedown, not just click —
  // intercept all of them in capture phase so we always win.
  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (evt) {
    document.addEventListener(evt, hijackHandler, true);
  });

  // Backstop: if the theme's native search modal opens anyway
  // (its listener beat ours), close it and open our overlay instead.
  function interceptNativeSearchModal() {
    try {
      if (!MOBILE_MQ || !MOBILE_MQ.matches) return;
      var host = document.getElementById('custom-mobile-algolia-search');
      var dialogs = document.querySelectorAll('dialog[open]');
      for (var i = 0; i < dialogs.length; i++) {
        var d = dialogs[i];
        if (host && host.contains(d)) continue;
        // Is this a search dialog? (has a search-ish input or class)
        var isSearch =
          d.querySelector('input[type="search"], input[name="q"]') ||
          /search/i.test(d.className || '');
        if (isSearch) {
          try { d.close(); } catch (e) { d.removeAttribute('open'); }
          openMobileSearch();
          return;
        }
      }
    } catch (e) {}
  }

  // Escape closes the overlay
  document.addEventListener('keydown', function (e) {
    try {
      if (e.key === 'Escape') closeMobileSearch();
    } catch (err) {}
  });

  // =====================================================
  // NOTE: the old MOBILE FILTER DRAWER lived here.
  //
  // It hijacked .ais-facets-button in the capture phase and
  // called stopImmediatePropagation(), which killed the click
  // before any other listener could see it — including the
  // modal in algolia_custom.js. That drawer is superseded by
  // initMobileFacets() / addMobileFacetsHeader() there, so it
  // has been removed along with its .custom-filter-close
  // button and the body.custom-mobile-filters-open class.
  //
  // Do not re-add a .ais-facets-button handler in this file.
  // =====================================================

  // If the theme re-renders and pulls the wrapper back into the
  // (hidden) desktop slot while we're on mobile, recapture it.
  // Run from the shared observer (runChecks).
  function checkMobilePlacement() {
    try {
      if (isInApp()) return;
      if (!MOBILE_MQ || !MOBILE_MQ.matches) return;
      interceptNativeSearchModal();
      var wrapper = getSearchWrapper();
      var host = document.getElementById('custom-mobile-algolia-search');
      if (!host) return;
      var slot = host.querySelector('.custom-mobile-search-slot');
      if (wrapper && slot && wrapper.parentNode !== slot) moveToMobile();
    } catch (e) {}
  }
})();